import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type UserTrialStatusChipKollegeUserFragment = { __typename?: 'KollegeUser', trials: Array<{ __typename?: 'KollegeUserTrial', status: Types.KollegeUserTrialStatus, schedule?: { __typename?: 'KollegeSchedule', startsAt: TimeString } | null }> };

export const UserTrialStatusChipKollegeUserFragmentDoc = gql`
    fragment UserTrialStatusChipKollegeUser on KollegeUser {
  trials {
    status
    schedule {
      startsAt
    }
  }
}
    `;